import axios from 'axios'
// import { cacheAdapterEnhancer } from 'axios-extensions'
import moment from 'moment';

export default {
  install (app) {
    app.config.globalProperties.$http = axios.create({
      baseURL: '/',
      // cache will be enabled by default
      // adapter: cacheAdapterEnhancer(axios.defaults.adapter)
    });
    app.config.globalProperties.$text1 = function () {// Función global 1
      alert('Ejecución exitosa 1');
    };
    app.config.globalProperties.$dateBackToFront = function (value, time = false) {
      if (value != null && value != undefined && value != '') {
        let resultDate = moment(value);
        if(value.includes('T')) {
          resultDate = resultDate.add(1, "hours").format("DD/MM/YYYY - HH:mm");
        }else {
          resultDate = resultDate.format("DD/MM/YYYY - HH:mm");
        }
        if(!time) {
          resultDate = moment(resultDate, 'DD/MM/YYYY - HH:mm').format('DD/MM/YYYY');
        }
        return resultDate;
      } else return "-";
    };
    app.config.globalProperties.$dateFrontToBack = function (value) {
      if (value != null && value != undefined && value != '') {
        let resultDate = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD');
        return resultDate;
      } else return "-";
    };
    app.config.globalProperties.$logOut = function () {
      try {
        this.$cookies.remove('token');
        this.$cookies.remove('channel');
        this.$cookies.remove('store');
        this.$cookies.remove('tenant');
        this.$cookies.remove('username');
        this.$cookies.remove('refreshToken');
        localStorage.clear();
        const toastContainer = document.getElementById('toast-container');
        const toastErrorContainer = document.getElementById('toast-error-container');
        toastContainer.style.opacity = "0";
        toastContainer.style.display = "none";
        toastErrorContainer.style.opacity = "0";
        toastErrorContainer.style.display = "none";
        this.$router.push({ name: 'login' })
        setTimeout(()=>{
          this.$store.commit("RESET_STATE");
        },1000)
      } catch (error) {
        console.log('error signing out: ', error);
      }
    };
    app.config.globalProperties.$getMonthName = function (monthNumber = 0, type = 'large') {
      const months = ["ENERO","FEBRERO","MARZO","ABRIL","MAYO","JUNIO","JULIO","AGOSTO","SEPTIEMBRE","OCTUBRE","NOVIEMBRE","DICIEMBRE"];
      let monthSelected = months[monthNumber];
      if(type === "short") {
        monthSelected = monthSelected.substring(0, 3);
      }
      return monthSelected;
    };
    app.config.globalProperties.$getMonthNumber = function (monthName = "ENERO") {
      let month = 1;
      switch (monthName) {
        case "ENERO":
        case "ENE":
          month = 1;
          break;
        case "FEBRERO":
        case "FEB":
          month = 2;
          break;
        case "MARZO":
        case "MAR":
          month = 3;
          break;
        case "ABRIL":
        case "ABR":
          month = 4;
          break;
        case "MAYO":
        case "MAY":
          month = 5;
          break;
        case "JUNIO":
        case "JUN":
          month = 6;
          break;
        case "JULIO":
        case "JUL":
          month = 7;
          break;
        case "AGOSTO":
        case "AGO":
          month = 8;
          break;
        case "SEPTIEMBRE":
        case "SEP":
          month = 9;
          break;
        case "OCTUBRE":
        case "OCT":
          month = 10;
          break;
        case "NOVIEMBRE":
        case "NOV":
          month = 11;
          break;
        case "DICIEMBRE":
        case "DIC":
          month = 12;
          break;
      }
      return month;
    };
    
  }
}